import { Layout } from '@/components/Layout';
import styles from '../onboarding.module.css';

const AccountPendingScreen = () => {
	return (
		<Layout includeSidebar={false} includeHeader={false}>
			<div className={styles.accountPendingContainer}>
				<img
					src="/images/svg/Time.svg"
					alt="Hourglass"
					height={150}
					width={150}
				/>
				<div className={styles.accountPendingContent}>
					<h1 className="font-semibold text-4xl text-black text-center">
						Your account approval is pending
					</h1>
					<p className="mt-8 text-neutral17">
						You're on the brink of unlocking the full potential of
						Xpress for Business. We're just a few steps away from
						getting started. To complete the process, please refer
						to the email we've sent to your registered email
						address. There, you'll find instructions on how to share
						the required documents. Once this step is done, you'll
						be all set to dive into the world of Xpress for Business
						and experience its myriad benefits.
					</p>
					<p className="mt-8 text-neutral17">
						Once we receive those documents, we'll review your
						account and contact you.
					</p>
					<p className="mt-4 font-semibold text-neutral17 tracking-[0.25px]">
						If you've already submitted your documents, our account
						review team will promptly verify them. You can expect to
						hear back from us within 72 hours regarding the status
						of your submission.
					</p>
					<p className="mt-3">
						{/* TODO: Change span to a link */}
						Questions?{' '}
						<span className="text-accent60 underline">
							Contact us
						</span>
					</p>
				</div>
			</div>
		</Layout>
	);
};

export default AccountPendingScreen;
